import React, { useEffect, useState, useRef} from 'react'
import { Table, Icon, Spin } from "antd";
import { Button, Modal } from "../../helpers/commonUi";
import { Http } from "../../helpers/axois";
import style from './navigation.module.sass';
import { ReactComponent as SettingsIcon } from '../../assets/svg/modalSettingsIcon.svg'
import { useHistory, useLocation } from 'react-router'
import CreateOrgModal from "../organization/CreateOrgs";
import { useDispatch, useSelector } from 'react-redux'
import { setCurrentOrganization, setOrgList, setOrgPermissions } from "../../stateManager/store/orgs/actions";
import { logger } from '../../constant/winston';
import SearchBar, {highlightMatch} from "../../helpers/SearchBar";

type align = 'left' | 'right' | 'center' | undefined

interface IProps {
  setOrgModalVisible: (data: boolean) => void,
  orgModalVisible: boolean
}

const OrgList = (props: IProps) => {

  const [filteredData, setFilterData] = useState<any[]>([])
  const searchRef = useRef<{ clearSearch: () => void }>(null);
  const [searchValue, setSearchValue] = useState<string>("")
  const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const currentOrganizationId = useSelector((state: any) => {
    return state.org.selectedOrg.id || state.uiState?.selectedOrg?.[state.user.data.user.id]
  })
  const orgList = useSelector((state: any) => {
    return state.org && state.org.orgList
  })
  const orgPermissions: any = useSelector((state: any) => {
    return state.org.orgPermissions
  }, (oldPermissions: any, newPermissions: any) => JSON.stringify(oldPermissions) === JSON.stringify(newPermissions))

  const alignRight: align = 'right';
  const alignLeft: align = 'left';

  const columns = [{
    title: "Name (identifier)",
    dataIndex: "orgName",
    key: "orgName",
    align: alignLeft,
    render: (value: string)=>{
      const formattedValue = highlightMatch(value, searchValue)
      return formattedValue
    }
  },
  {
    title: "Display Name",
    dataIndex: "displayName",
    key: "displayName",
    render: (value: string)=>{
      const formattedValue = highlightMatch(value, searchValue)
      return formattedValue
    }
  },
  {
    title: "Description",
    dataIndex: "description",
    key: "description",
    align: alignRight,
    ellipsis: true,
    render: (value: string)=>{
      const formattedValue = highlightMatch(value, searchValue)
      return formattedValue
    }
  }
  ]

  const [createModalVisible, setCreateModalVisible] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(true)
  const [rowKey, setRowKey] = useState<any[]>([])
  const [isOrgChanged, setIsOrgChanged] = useState<boolean>(false)
  const [onRowRecord, setOnRowRecord]: any = useState({});

  useEffect(() => {
    getOrgs()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getPermissions = async (orgId: string) => {
    try {
      const res = await Http.get(`/orgs/${orgId}/permissions`).toPromise()
      return res
    } catch (e) {
      logger.error(e)
    }
  }

  useEffect(() => {
    if (orgList && !orgList.length) {
      //Clear selected org if no org is present
      dispatch(setOrgPermissions({ orgPermissions: [] }))
    } else if (orgList && orgList.length > 0) {
      const currentOrg = orgList.find((org: any) => org.id === currentOrganizationId)
      if (currentOrg) {
        //Auto select org if org is present in the redux store
        // setRowKey(orgList.filter( (item:any) => item.id === currentOrganizationId).map((item:any) => item.id))
        (async () => {
          const permissions: any = await getPermissions(currentOrganizationId)
          if (JSON.stringify(orgPermissions) !== JSON.stringify(permissions ? permissions.permissions : [])) {
            dispatch(setOrgPermissions({ orgPermissions: permissions ? permissions.permissions : [] }))
            dispatch(setCurrentOrganization({ selectedOrg: { id: currentOrg.id, orgName: currentOrg.orgName, owner: currentOrg.created_by } }))
          }
        })()
        setRowKey([currentOrganizationId])
        setOnRowRecord(currentOrg)
      } else {
        //Select first org from the list if redux org is not present in the api orgList
        (async () => {
          const permissions: any = await getPermissions(orgList[0].id)
          dispatch(setOrgPermissions({ orgPermissions: permissions ? permissions.permissions : [] }))
          dispatch(setCurrentOrganization({ selectedOrg: { id: orgList[0].id, orgName: orgList[0].orgName, owner: orgList[0].created_by } }))
        })()
        setRowKey([orgList[0].id])
        setOnRowRecord(orgList)
      }
    }
  }, [orgList])

  useEffect(() => {
    if(isOrgChanged){
      permissionChange();
    }
  },[isOrgChanged])

  const getOrgs = () => {
    searchRef.current?.clearSearch()
    Http.get("/orgs/list").subscribe(
      (res: any) => {
        dispatch(setOrgList({
          orgList: res
        }))
        setFilterData(res)
        setLoading(false)
      }, (err: any) => {
        setFilterData([])
        setLoading(false)
      }
    );
  }


  const permissionChange = async () => {
    const permissions: any = await getPermissions(onRowRecord?.id)
    dispatch(setOrgPermissions({ orgPermissions: permissions ? permissions.permissions : [] }))
    dispatch(setCurrentOrganization({ selectedOrg: { id: onRowRecord.id, orgName: onRowRecord.orgName, owner: onRowRecord.created_by } }))
    props.setOrgModalVisible(false)
    searchRef.current?.clearSearch()
  }

  const gotoAppsScreen = () => {
    const regex = new RegExp(
    '\/apps\/list.*|' +
    '\/organization\/.+\/env|' +
    '\/organization\/.+\/teams|' +
    '\/organization\/.+\/themeManager\/.+|' +
    '\/organization\/.*\/(downloads|audit)$'
  )
    if (regex.test(location.pathname)) {
      history.push("/apps/list");
    }
  }

  return (
    <React.Fragment>
      <Modal
        id='orgListModal'
        dataTestId="org_list_modal"
        className={style.orglistModal}
        title={
          <div className={style.orgListModalHeader}>
            <span>ORGANIZATIONS</span>
            <div className='flex ' style={{alignItems: "center", gap:"14px"}}>
              <SearchBar
                mode="modal"
                ref={searchRef}
                data={orgList}
                columns={columns}
                onFilter={(filteredData ) => {
                  setFilterData(filteredData)
                }}
                onSearchTermChange={ (searchValue: string)=>{ setSearchValue(searchValue) } }
              />
              {orgList && orgList.length > 0 ?
                <SettingsIcon data-test-id="settings_icon" style={{ cursor: 'pointer' }} onClick={() => {
                  props.setOrgModalVisible(false)
                  searchRef.current?.clearSearch()
                  history.push("/organization")
                }} />
                :
                null
              }
              <Button dataTestId="org_list" color="primary-light-outlined" size="small" onClick={() => {
                // --- Anyone can create organization, hence below code is not required
                // if(canCreateOrg){
                //   setCreateModalVisible(true)
                // }else {
                //   toast({
                //     type: 'error',
                //     message: 'You are not authorized to create organizations'
                //   })
                // }
                setCreateModalVisible(true)
                props.setOrgModalVisible(false)
                searchRef.current?.clearSearch()
              }}
              >
                CREATE ORGANIZATION
              </Button>
            </div>
          </div>
        }
        closable={false}
        visible={props.orgModalVisible}
        onCancel={() => {
          searchRef.current?.clearSearch()
          props.setOrgModalVisible(false)
          if (isOrgChanged) {
            history.push("/apps/list")
            setIsOrgChanged(false)
          }
        }}
        unmountOnCancel={true}
        footer={{
          enable: false
        }}
        // mode='EditCreate'
        width="60vw"
      >
        {
          !loading
            ?
            <Table
              pagination={false}
              columns={columns}
              scroll={{ y: 450 }}
              rowSelection={{
                type: 'radio',
                selectedRowKeys: rowKey,
                onChange: async (key, record: any) => {
                  const newKeyArray = []
                  newKeyArray.push(key[0])
                  setRowKey(newKeyArray)
                  if (record[0].id !== currentOrganizationId) {
                    setIsOrgChanged(true)
                  }
                  setOnRowRecord(record[0])
                }
              }}
              onRow={(record: any, rowIndex: any) => {
                return {
                  'data-test-id': 'orglist_table_row_' + record.key,
                  onClick: async (event: any) => {
                    const newKeyArray = []
                    newKeyArray.push(record.id)
                    setRowKey(newKeyArray)
                    setOnRowRecord(record);
                  }
                };
              }}
              className={"override-table-container"}
              dataSource={filteredData && filteredData.map((res: any) => {
                return { ...res, key: res.id };
              })}
            />
            :
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <Spin indicator={antIcon} style={{ color: '#15808C' }} />
            </div>
        }

        {/* <Divider type='horizontal' /> */}
        <div style={{
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "10px",
          borderTop: "1px solid #e8e8e8",
          padding: "12px 16px 0px 16px"
        }}>
          <Button dataTestId="cancel" color="light" size="small"
          style={{
            backgroundColor: "#FFFFFF",
            border: "1px solid #51808C",
            boxShadow: "none",
            color: "#51808C",
          }}
            onClick={() => {
              searchRef.current?.clearSearch()
              props.setOrgModalVisible(false);
              const currentOrg = orgList.find((org: any) => org.id === currentOrganizationId)
              setOnRowRecord(currentOrg)
              setRowKey([currentOrganizationId])
            }} >CANCEL</Button>
          <Button
            dataTestId="ok"
            color={"shadow-primary"}
            size="small"
            // disabled={props.footer.disableOkButton}
            onClick={() => {
              searchRef.current?.clearSearch()
              permissionChange();
              gotoAppsScreen();
            }}
          >OK</Button>
        </div>

      </Modal>

      <CreateOrgModal loadAPIcards={getOrgs} visible={createModalVisible} visibleChange={setCreateModalVisible} setParentModalVisibility={props.setOrgModalVisible} setRowKey={setRowKey} />

    </React.Fragment>
  )
}

export default OrgList
